import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

export const LazyBoardsMenu = () => {
  const BoardsMenu = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "boards-menu" */ 'app/gamma/src/components/boards-menu'
      ),
    { preload: false },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <BoardsMenu />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
